import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=bf84bd28&scoped=true"
import script from "./CarInfo.vue?vue&type=script&lang=js"
export * from "./CarInfo.vue?vue&type=script&lang=js"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=bf84bd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf84bd28",
  null
  
)

export default component.exports